/* QUOTES */
export const GET_QUOTES = "GET_QUOTES"
export const GET_QUOTES_SUCCESS = "GET_QUOTES_SUCCESS"
export const GET_QUOTES_FAIL = "GET_QUOTES_FAIL"


/* GET_QUOTE_DETAIL */
export const GET_QUOTE_DETAIL = "GET_QUOTE_DETAIL"
export const GET_QUOTE_DETAIL_SUCCESS = "GET_QUOTE_DETAIL_SUCCESS"
export const GET_QUOTE_DETAIL_FAIL = "GET_QUOTE_DETAIL_FAIL"


/**
 * add QUOTE
 */
 export const ADD_NEW_QUOTE = "ADD_NEW_QUOTE"
 export const ADD_QUOTE_SUCCESS = "ADD_QUOTE_SUCCESS"
 export const ADD_QUOTE_FAIL = "ADD_QUOTE_FAIL"
 
 /**
  * Edit QUOTE
  */
 export const UPDATE_QUOTE = "UPDATE_QUOTE"
 export const UPDATE_QUOTE_SUCCESS = "UPDATE_QUOTE_SUCCESS"
 export const UPDATE_QUOTE_FAIL = "UPDATE_QUOTE_FAIL"
 
 /**
  * Delete QUOTE
  */
 export const DELETE_QUOTE = "DELETE_QUOTE"
 export const DELETE_QUOTE_SUCCESS = "DELETE_QUOTE_SUCCESS"
 export const DELETE_QUOTE_FAIL = "DELETE_QUOTE_FAIL"
 

